import { AISHA_API_BASE } from '@/constants';

export interface PhoneUser {
  id: string;
  phoneNumber: string;
  name: string;
}

export const validatePhoneToken = async (): Promise<PhoneUser | null> => {
  try {
    // クッキーから読み込み
    const cookies = document.cookie.split(';');
    let phoneUser = null;
    
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'phone_user' && value) {
        try {
          phoneUser = JSON.parse(decodeURIComponent(value));
          break;
        } catch (e) {
          console.error('Failed to parse phone cookie:', e);
        }
      }
    }
    
    if (!phoneUser || !phoneUser.id) {
      return null;
    }

    return {
      id: phoneUser.id,
      phoneNumber: phoneUser.phoneNumber,
      name: phoneUser.name
    };
  } catch (error) {
    console.error('Phone token validation error:', error);
    return null;
  }
};

export const phoneLogout = async (): Promise<void> => {
  // クッキーを削除
  document.cookie = 'phone_user=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
};